<template>
  <div class="ml-6 mr-6 mt-2" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-alert v-if="alert" class="mb-3" border="top" :color="colorAlert" dark>
      {{ message }}
    </v-alert>
    <!--TOPIC DAN PEROIDE BERITA-->
    <v-layout
      :class="{
        'd-flex ma-0 pa-0 ml-1 justify-center': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
        'd-flex ma-0 pa-0 ml-1': showDateStart != '' && showDateEnd != '' && isShowDate == true
      }"
      row
      wrap
    >
      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="topicsentiment"
          item-text="TOPIC"
          item-value="SEQ_ID"
          v-model="selectedTopic"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Topic"
          dense
          outlined
          rounded
          @change="parameter_proses_topic()"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0 ml-3" cols="12" sm="2">
        <v-select
          :items="topickeywordsentiment"
          v-model="selectedTopic2"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Keyword"
          dense
          outlined
          rounded
          @change="parameter_proses_keyword"
        ></v-select>
      </v-col>

      <v-col class="d-flex ma-0 pa-0 ml-3" cols="12" sm="2">
        <v-select
          :items="periodeberita"
          v-model="selectedPeriode"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Periode"
          dense
          outlined
          rounded
          @change="parameter_proses_periode"
        >
          <template v-slot:append-item>
            <v-list-item>
              <v-list-item-title>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      dark
                      width="120"
                      color="var(--color-theme)"
                    >
                      Custom
                    </v-btn>
                  </template>
                  <v-card>
                    <v-row class="pa-8" justify="space-around">
                      <v-date-picker
                        v-model="dateStart"
                        :show-current="false"
                        class="custom-date-picker"
                        color="var(--color-theme)"
                        @change="showPeriodeDate"
                      ></v-date-picker>
                      <v-date-picker
                        v-model="dateEnd"
                        :show-current="false"
                        class="ml-8 custom-date-picker"
                        color="var(--color-theme)"
                        @change="showPeriodeDate"
                      ></v-date-picker>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#000" text @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn color="var(--color-theme)" text @click="menu = false, parameter_proses_custom()">
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-select>
      </v-col>

      <v-col
        v-if="showDateStart != '' && showDateEnd != ''"
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="3"
      >
        <v-card style="border-radius: 30px; width: 100%;" height="40" outlined>
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2 ml-1">
              {{ showDateStart[1] + " " + showDateStart[0] + " " + showDateStart[2] }} - {{ showDateEnd[1] + " " + showDateEnd[0] + " " + showDateEnd[2] }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>

      <!--Data Source-->
      <v-col class="d-flex ma-0 pa-0 ml-3" cols="12" sm="2">
        <v-select
          :items="itemsDataSource"
          item-text="NAME_SOCIAL_MEDIA"
          item-value="ID"
          v-model="selectedDataSource"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Data Source"
          dense
          outlined
          rounded
          @change="parameter_proses_topic()"
        ></v-select>
      </v-col>

      <!-- Button Hit API -->
      <v-col
        :class="{
          'd-flex ma-0 pa-0 ml-3': (showDateStart == '' && showDateEnd == '') || (showDateStart != '' && showDateEnd != '' && isShowDate == false),
          'd-flex ma-0 pa-0': showDateStart != '' && showDateEnd != '' && isShowDate == true
        }"
        cols="12"
        sm="1"
      >
        <v-btn
          color="var(--color-theme-secondary)"
          style="max-width: 100%;"
          height="40"
          dense
          dark
          rounded
          block
          @click="isSearch = true, loadDiscoverPerson()"
        >
          <v-icon>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>

      <v-col
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="1"
      >
        <v-btn
          v-if="isColorThemeSetneg"
          color="var(--color-theme)"
          style="max-width: 100%;"
          height="40"
          outlined
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>

        <v-btn
          v-else
          class="white--text"
          height="40"
          color="#a80202"
          variant="outlined"
          style="max-width: 100%;"
          rounded
          block
          @click="dialogConfirmReset = true"
        >
          <v-icon>mdi-reload</v-icon>
          Reset
        </v-btn>
      </v-col>
      <!-- End Button Hit API -->
    </v-layout>

    <v-layout row wrap>
      <v-flex lg8>
        <v-card color="#F4F7FA" class="mb-6 rounded-lg" flat>

          <v-row class="ma-2 pa-0 ml-0 mx-0 ma-0">
            <v-flex lg12 sm12 md12 xs12>
              <v-card height="430px" class="mx-4 mb-6 rounded-lg pa-4" flat>
                <v-card-title>Periodic Content</v-card-title>
                <div>
                  <apexcharts
                    :options="sentimentanalysis"
                    :series="seriessentiment"
                    class="mt-4 py-4"
                    type="area"
                    width="100%"
                    height="360px"
                  ></apexcharts>
                </div>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>

      <v-flex lg4>
        <v-card color="#F4F7FA" class="mb-6 rounded-lg" flat>
          <v-row class="ma-2 pa-0 ml-0 mx-0 ma-0">
            <v-flex lg12 sm12 md12 xs12>
              
              <v-card height="430px" class="mx-4 mb-6 rounded-lg pa-4" flat>
                  <v-card-title>Person Bubble</v-card-title>
                <div>
                  <Toppersonbubblepinnedhistory
                    ref="topPersonComponent"
                    :selectedTopic2="selectedTopic2"
                    :selectedTopic="selectedTopic"
                    :selectedPeriode="selectedPeriode"
                    :statusFilter="statusFilter"
                    :isClickBubleOrg="isClickBubleOrg"
                    :isClickWord="isClickWord"
                    :resetcolorClicked="resetcolorClicked"
                    :updateSocket="updateSocket"
                    @bubble-clicked="handleBubbleClick"
                  ></Toppersonbubblepinnedhistory>
                </div>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-2">
      <v-flex lg12>
        <v-card  class="mx-4 rounded-lg pa-4 overflow-card" flat>
          <v-card-title>Content List Person</v-card-title>
          <v-tabs color="#0471A5"  v-model="activeTab">
            <v-tab  style="position: -webkit-sticky;position: sticky;top: 0;z-index: 1000;"  v-for="item in listDataContent" :key="item.person_id" @click="page = 1, loadDiscoverPersonContent(item)">
              {{ item.person }}
              <v-chip small class="ma-2" color="#0471A5" text-color="white">
                {{ item.count_chart }}
              </v-chip>
            </v-tab>
            <v-tab-item  v-for="item in listDataContent" :key="item.person_id">
              <!-- <v-flex v-for="item in listContent" :key="item.id" lg12> -->
              <v-flex v-for="(item, index) in listContent" :key="item.id" lg12>
                <v-card
                  :href="item.url"
                  target="_blank"
                  flat
                  :class="{'rounded-lg custom-card': index === 0, 'mt-2 rounded-lg custom-card': index !== 0}"
                  style="border-radius: 8px; border: 0.6px solid #E4E4E4; background: #FFF;"
                >
                  <div class="d-flex flex-no-wrap justify-space-between">
                    <div>
                      <v-list-item three-line>
                        <v-list-item-content>
                          <v-list-item-title class="body-1" style="width: 300px; text-wrap: wrap;">
                            {{ item.title }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap;">
                            {{ item.content }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="mt-1" style="width: 300px; text-wrap: wrap; display: flex; flex-direction: column;">
                            <div class="d-flex align-center">
                              <v-avatar v-if="sourceCollection == 'NEWS'" class="color-avatarberitaonline" size="26">
                                <v-icon class="white--text" size="18">
                                  fa-thin fa-globe
                                </v-icon>
                              </v-avatar>

                              <v-avatar v-if="sourceCollection == 'TWITTER'" class="color-avatarXTikTok" size="26">
                                <v-icon class="white--text" size="22">
                                  fa-brands fa-x-twitter
                                </v-icon>
                              </v-avatar>

                              <v-avatar v-if="sourceCollection == 'YOUTUBE'" class="color-avatarYtb" size="26">
                                <v-icon class="white--text" size="18">
                                  fa-brands fa-youtube
                                </v-icon>
                              </v-avatar>

                              <v-avatar v-if="sourceCollection == 'TIK TOK'" class="color-avatarXTikTok" size="26">
                                <v-icon class="white--text" size="22">
                                  fa-brands fa-tiktok
                                </v-icon>
                              </v-avatar>

                              <v-avatar v-if="sourceCollection == 'INSTAGRAM'" class="color-avatarIG" size="26">
                                <v-icon class="white--text" size="22">
                                  mdi-instagram
                                </v-icon>
                              </v-avatar>
                              <span class="ml-1" style="font-style: italic; font-size: 12px; color: #439EDF; overflow-wrap: break-word;">
                                {{ item.url }}
                              </span>
                            </div>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                  </div>
                </v-card>
              </v-flex>
            </v-tab-item>
          </v-tabs>
        </v-card>
        <div  class="text-center">
          <v-pagination
            class="mt-2 my-2"
            v-model="page"
            :length="pagelength"
            :total-visible="8"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            @input="handlePageChange"
          ></v-pagination>
        </div>
      </v-flex>

      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h6 font-weight-medium align-center justify-center">
            Page loading
          </v-card-title>
          <v-card-text class="body-1 align-center justify-center">
            Loading content, please wait
          </v-card-text>
          <v-card-title class="align-center justify-center">
            <v-progress-circular
              color="var(--color-theme)"
              :size="70"
              :width="7"
              indeterminate
            ></v-progress-circular>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="var(--color-theme)" text @click="dialog = false">
              cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmReset" width="330px">
        <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
          <v-btn class="confirm-reset ma-0 pa-0" color="#aaa" small icon @click="dialogConfirmReset = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-avatar style="border: 2px solid #ddd;" color="#eee" size="80">
            <v-icon class="white--text" size="80">
              mdi-check
            </v-icon>
          </v-avatar>

          <h1 class="mt-2 text-center text-h6 align-center justify-center">
            Are you sure?
          </h1>

          <v-card-text class="align-center justify-center mt-2">
            Are you sure you want to reset?
          </v-card-text>

          <v-divider class="mt-4"></v-divider>

          <v-card-actions class="align-center justify-center">
            <v-btn
              color="#0471A5"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              size="large"
              dark
              outlined
              @click="dialogConfirmReset = false"
            >
              Cancel
            </v-btn>
            <v-btn
              class="my-3"
              width="120px"
              height="40px"
              style="borderRadius: 8px"
              color="#e30700"
              size="large"
              dark
              @click="
                dialogConfirmReset = false,
                selectedPortal = '',
                selectedPortalId = '',
                changeBackgroundColor = false,

                filterReset(),
                loadTopic(),
                parameter_proses_periode()
              "
            >
              Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div>
        <Notification ref="alert"></Notification>
      </div>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import { decryptionData, generate_filterdate } from '@/components/utils/utils.js';
import VueApexCharts from 'vue-apexcharts';
import Notification from '@/components/Notification';
import Toppersonbubblepinnedhistory from '@/components/Toppersonbubblepinnedhistory';
import { mapGetters } from 'vuex';

export default {
  components: {
    Toppersonbubblepinnedhistory,
    apexcharts: VueApexCharts,
    Notification: Notification
  },
  data: function() {
    return {
      sourceCollection: "",
      selectedDataSource: 0,
      itemsDataSource:[],
      listPerson: "",
      listDataChart: "",
      listDataContent: "",
      selectedContent: "",
      selectedPerson: "",
      listContent: "",
      menu: false,
      dialog: false,
      dialogConfirmReset: false,
      click: "",
      selectedTopic: "",
      selectedTopic2: "",
      selectedPeriode: "This Week",
      topicsentiment: [],
      topickeywordsentiment: [],
      periodeberita: ['Today', 'From Yesterday', 'This Week', 'Previous Week', 'This Month', 'Previous Month'],
      isShowDate: false,
      showDateStart: "",
      showDateEnd: "",
      dateStart: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      dateEnd: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      pageplay: 10,
      page: 1,
      pagelength: 0,
      activeTab:"",
      statusFilter: "",
      isClickBubleOrg: "",
      isClickWord: "",
      resetcolorClicked: false,
      updateSocket: "",
      alert: false,
      colorAlert: "",
      message: "",
      Settanggal: [],
      startDate: [],
      endDate: [],
      sentimentanalysis: {
        chart: {
          id: 'Memory Usage',
          background: 'transparent',
          events: {
            markerClick: (event, chartContext, {  dataPointIndex, w }) => {
              const category = w.globals.categoryLabels[dataPointIndex]
              this.onPointClick(category)
            }
          }
        },

        tooltip: {
          shared: true,     
          intersect: false, 
           followCursor: true, 
          x: {
            show: true,     
            format: 'yyyy-MM-dd' // atau sesuaikan jika bukan format tanggal
          },
          y: {
            formatter: function(val) {
              return val != null ? val : '0';
            }
          }
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
          connectNulls: true
        },
        colors: ['#45AF5B', '#FF1752', '#008FFB', '#FFB000', '#814AD6', '#000'],
        xaxis: {
          type: 'category', // pastikan ini ada
          // categories: [],
          labels: {
            style: {}
          }
        },
        yaxis: {
          labels: {
            style: {}
          }
        }
      },
      seriessentiment: []
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']),
    themeItemColor() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700' ? 'var(--color-theme)' : undefined;
    },
    isColorThemeSetneg() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700';
    }
  },
  mounted() {
    this.loadTopic();
  },
  methods: {

    handleBubbleClick(clickedName) {
         const index = this.listDataContent.findIndex(item => item.person === clickedName);
        if (index !== -1) {
          console.log(index)
          this.activeTab = index;
          // panggil juga action-nya jika perlu:
          this.page = 1;
          this.loadDiscoverPersonContent(this.listDataContent[index]);
        } else {
          // console.warn("Organization tidak ditemukan:", clickedName);
        }
    },
    filterReset() {
      this.$store.commit("addButtonTmp", {
        sentiment_glob: "",
        ner_person_glob: "",
        ner_organization_glob: "",
      });
    },

    showPeriodeDate() {
      this.isShowDate = true;

      var date = new Date(this.dateStart);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");
      dateString = dateString.split(" ");
      this.showDateStart = dateString;
      var date3 = new Date(this.dateEnd);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();
      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");
      dateString2 = dateString2.split(" ");
      this.showDateEnd = dateString2;

      let jenisParameter = "";
      if (this.selectedPeriode == "Custom") {
        jenisParameter = "custom";
      } else {
        jenisParameter = "periode";
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: jenisParameter,
        topic_glob: this.selectedTopic,
        topic_glob2: this.selectedTopic2,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: this.dateStart,
        date_end_glob: this.dateEnd,
        is_show_date_glob: this.isShowDate
      });
    },
    async loadTopic() {
      this.dialog = true;
      axios.get("keyword_select",
        { 
          headers: { 'auth-token': localStorage.getItem('token_app') } ,
          dataType: 'json',
          validateStatus: function (status) {
            return status === 200; // hanya status 200 yang dianggap sukses
          }

      })
      .then((response) => {
        const data_dec = decryptionData(response.data.token);
        this.posts = data_dec.keyword;
        const data = data_dec.keyword;
        for (let i = 0; i < data.length; i++) {
          //sincron data topic sentiment
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob == undefined) {
              this.selectedTopic = data[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicsentiment.push(data[i]);
        }
        this.$store.commit("addTopicKeyword", {
          //send parameter store
          topickeywordsentiment_glob: data,
        });
        this.topickeywordsentiment = [];
        let all = "All";
        for (let i = 0; i < data.length; i++) {
          //sincron data topic sentiment
          if (data[i].SEQ_ID == this.selectedTopic) {
            this.topickeywordsentiment.push(all);
            for (let x = 0; x < data[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                  this.selectedTopic2 = all;
                } else {
                  this.selectedTopic2 = this.$store.topic_glob2;
                }
              }
              this.topickeywordsentiment.push(data[i].KEYWORD[x].KEYWORD);
            }
          }
        }

        this.isShowDate = this.$store.is_show_date_glob;
        var date_start = this.dateStart;
        var date_end = this.dateEnd;
        if (this.$store.jenis_parameter_glob == "custom") {
          date_start = this.$store.date_start_glob;
          date_end = this.$store.date_end_glob;
        } else {
          let period = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
          let date_v = generate_filterdate(period);
          date_start = date_v.start_date;
          date_end = date_v.end_date;
        }

        // coolection parameter 
        if (this.$store.collectionstore == "" || this.$store.collectionstore == undefined) {
            this.$store.commit("collectionactive", {
              collection_send: data_dec.collection,
              collection_select_send:  data_dec.collection[0].ID,
            });
            this.itemsDataSource =data_dec.collection;
            this.selectedDataSource =  data_dec.collection[0].ID ;
        }else{
            this.itemsDataSource = data_dec.collection;
            this.selectedDataSource =this.$store.collectionSelectstore;
        }
        // end coolection parameter 
        if (this.$store.date_start_glob == "" || this.$store.date_start_glob == undefined) {
          // send parameter store
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedTopic2,
            data_source_glob: this.selectedDataSource,
            selectedPeriode_glob: this.selectedPeriode,
            date_start_glob: date_start,
            date_end_glob: date_end,
            is_show_date_glob: this.isShowDate
          });
        } else {
          this.selectedTopic2 = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.dateStart = this.$store.date_start_glob;
          this.dateEnd = this.$store.date_end_glob;
        }
        if (data.length > 0) {
          this.loadDiscoverPerson();
        }
        if (this.isShowDate == true) {
          this.showPeriodeDate();
        }

        setTimeout(() => {
          this.dialog = false;
        }, 3000);
      })
      .catch((e) => {
        if (!e.data_dec) {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 3000);
          this.message = "API Keyword Select refused to connect";
          this.colorAlert = "red";
        }
        const status = e.response?.status;
        const msg = e.response?.msg;
        this.errors = msg;
        switch (status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.log("some other error"); // end up here all the time
            break;
        }
      });
    },

    async parameter_proses_topic() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      this.topickeywordsentiment = [];
      let all = "All";
      for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
        if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
          this.topickeywordsentiment.push(all);
          for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
            if (x == 0) {
              if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                this.selectedTopic2 = all;
              } else {
                this.selectedTopic2 = this.$store.topic_glob2;
              }
            }
            this.topickeywordsentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
          }
        }
      }
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameter_proses_keyword() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
      this.parameter_proses_periode();
    },
    async parameter_proses_periode() {
      let date_start = this.dateStart;
      let date_end = this.dateEnd;
      if (this.selectedPeriode != 'Custom') {
        let period = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let date_v = generate_filterdate(period);
        date_start = date_v.start_date;
        date_end = date_v.end_date;
        this.dateStart = date_start;
        this.dateEnd = date_end;
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
      this.showPeriodeDate();
    },
    async parameter_proses_custom() {
      this.selectedPeriode = "Custom";
      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },

    onPointClick(date) {

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedTopic2,
        topic_glob: this.selectedTopic,
        data_source_glob: this.selectedDataSource,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date,
        date_end_glob: date,
        is_show_date_glob: this.isShowDate
      });
      this.loadDiscoverPerson();
    },
    async loadDiscoverPerson() {
      let source = this.selectedDataSource;
      if(this.selectedDataSource == undefined){
        source = this.$store.data_source_glob;
      }
      this.dialog = true;
      axios.post("/pinned-history-discover-person",
        {
          "start_date": this.$store.date_start_glob,
          "end_date": this.$store.date_end_glob,
          "topic_id": this.$store.topic_glob,
          "keyword": this.$store.topic_glob2,
          "source": source,
          "startpage": 0,
          "pageShow": this.pageplay
        },
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      )
      .then((response) => {
        const data_res = decryptionData(response.data.token);

        if(data_res.status == 200){
              
            this.listPerson = data_res.data_bubble;
            this.$store.commit("dataBubble", {bubble_data: data_res});
            this.$refs.topPersonComponent.loadKontenBerita();
            this.listDataChart = data_res.data_chart;
            this.listDataContent = data_res.data_chart.slice(0, 6);


            this.listDataChart = data_res.data_chart;

            const allDatesSet = new Set();
            this.listDataChart.forEach(item => {
              item.chart_date.forEach(dateItem => {
                allDatesSet.add(dateItem.period);
              });
            });
            const allDates = Array.from(allDatesSet).sort(); // semua tanggal unik

            this.seriessentiment = [];
            this.listDataChart.forEach((item) => {
              const dateMap = new Map();
              item.chart_date.forEach(dateItem => {
                dateMap.set(dateItem.period, dateItem.jumlah);
              });

              const dataFormatted = allDates.map(date => {
                return {
                  x: date,
                  y: dateMap.get(date) ?? 0  
                  
                };
              });

              this.seriessentiment.push({
                name: item.person,
                data: dataFormatted
              });
            });
              // console.log(this.listDataChart)
            this.loadDiscoverPersonContent(data_res.data_chart[0])
            window.dispatchEvent(new Event("resize"));
            setTimeout(() => {
              this.dialog = false;
            }, 3000);

        }else{
            this.dialog = false;
            this.$refs.alert.error_response(204,data_res.msg);
        }
        
      })
      .catch((e) => {
        if (!e.data_res) {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 3000);
          this.message = "API pinned-history-discover-person refused to connect";
          this.colorAlert = "red";
        }
        this.errors = e.data_res.data.msg;
        switch (e.data_res.status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.log("some other error"); // end up here all the time
            break;
        }
      });
    },
    async loadDiscoverPersonContent(item) {
    this.page = 1
      this.selectedContent = item.person_id;
      this.selectedPerson = item.person;
      this.dialog = true;
      
      let source = this.selectedDataSource;
      if(this.selectedDataSource == undefined){
        source = this.$store.data_source_glob;
      }
      axios.post("/pinned-history-content",
        {
          "start_date": this.$store.date_start_glob,
          "end_date": this.$store.date_end_glob,
          "topic_id": this.$store.topic_glob,
          "keyword": this.$store.topic_glob2,
          "person_id": this.selectedContent,
          "source": source,
          "startpage": 0,
          "pageShow": this.pageplay
        },
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      )
      .then((response) => {
        // alert('aaa')
        const data_res = decryptionData(response.data.token);
        this.listContent = data_res.data_content.content;
        this.sourceCollection = data_res.data_content.sourceCollection;
        this.pagelength = data_res.data_content.pageleght;
        window.dispatchEvent(new Event("resize"));
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      })
      .catch((e) => {
        if (!e.data_res) {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 3000);
          this.message = "API pinned-history-content refused to connect";
          this.colorAlert = "red";
        }
        this.errors = e.data_res.msg;
        switch (e.data_res.status) {
          case 404:
            this.$refs.alert.error_login(404);
            break;
          case 403:
            this.$refs.alert.error_login(403);
            break;
          default:
            console.log("some other error"); // end up here all the time
            break;
        }
      });
    },
    async handlePageChange(value) {
      this.dialog = true;
      const startPage = this.pageplay * (value - 1);
      
      let source = this.selectedDataSource;
      if(this.selectedDataSource == undefined){
        source = this.$store.data_source_glob;
      }
      try {
        const data1 = await axios
          .post("/pinned-history-content",
            {
              "start_date": this.$store.date_start_glob,
              "end_date": this.$store.date_end_glob,
              "topic_id": this.$store.topic_glob,
              "keyword": this.$store.topic_glob2,
              "person_id": this.selectedContent,
              "source": source,
              "startpage": startPage,
              "pageShow": this.pageplay
            },
            { headers: { 'auth-token': localStorage.getItem('token_app') } },
            { dataType: 'json' }
          )
          const data_res = decryptionData(data1.data.token);
          this.listContent = data_res.data_content.content;
          this.sourceCollection = data_res.data_content.sourceCollection;
          setTimeout(() => {
            this.dialog = false;
          }, 1000);
      } catch (e) {
        console.log(e);
        setTimeout(() => {
          this.dialog = false;
        }, 1000);
      }
    }
  }
}
</script>

<style scoped>
.custom-date-picker ::v-deep .v-date-picker-table button {
  color: #000000 !important;
}
.custom-date-picker ::v-deep .v-date-picker-table button.v-btn--active {
  background-color: var(--color-theme) !important;
  color: #ffffff !important;
}
.confirm-reset {
  position: absolute; top: 10px; right: 10px;
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}
div.apexcharts-canvas.apexcharts-theme-dark {
  background: transparent !important;
}
::v-deep .apexcharts-toolbar,
::v-deep .apexcharts-menu {
  z-index: 1 !important;
}
.tooltip .tooltip-inner {
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 12px !important;
  max-width: 150px;
}
.row-pointer {
  cursor: pointer;
}
.btn-ok {
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}
.v-avatar.color-avatarberitaonline {
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}
.v-avatar.color-avatarXTikTok {
  background-image: linear-gradient(to right top, #000000, #000000) !important;
}
.v-avatar.color-avatarYtb {
  background-image:
  linear-gradient(to right top, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000) !important;
}
.v-avatar.color-avatarIG {
  background-image:
  linear-gradient(to right top, #f09433, #e6683c, #dc2743, #cc2366, #bc1888, #cb33b4, #d844ee, #ffdc80);
}

.v-window-item {
  /* height: auto; */
  max-height: 100%; /* Ensures it doesn't overflow */
  height: 500px; /* Set the desired height */
  overflow-y: auto;
}
</style>
